import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Box, Divider, ListItemIcon, ListItemText, MenuItem, Popover, Typography } from '@mui/material';
import { useAuth } from '@hooks/use-auth';
import { UserCircle as UserCircleIcon } from '@icons/user-circle';
import { useTranslation } from 'react-i18next';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import PersonIcon from '@mui/icons-material/Person';
import { permissionService } from '@services/permission-service';
import { useSettings } from '@hooks/use-settings';

export const AccountPopover = function AccountPopover(props) {
  const { anchorEl, onClose, open, returnUrl, ...other } = props;
  const router = useRouter();
  const { t } = useTranslation();
  const { logout, permissions } = useAuth();
  const { user } = useAuth();
  const { authType } = useSettings();
  
  const handleMyAccount = async () => {
    router.push('/admin/account');
  };
  const handleDashboard = async () => {
    router.push('/admin');
  };
  const handleLogout = async () => {
    try {
      (authType.includes('saml2')) 
        ? window.location.href = `${process.env.apiPath}/saml2/ciges/logout`
        : await logout(authType);
      if (returnUrl) router.push('/authentication/login');
    } catch (err) {
      console.log(err);
      toast.error('Unable to logout.');
    }
  };
  if (user != null) {
    return (
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        keepMounted
        onClose={onClose}
        open={open}
        PaperProps={{ sx: { width: 300 } }}
        transitionDuration={0}
        {...other}>
        <Box
          sx={{
            alignItems: 'center',
            p: 2,
            display: 'flex',
          }}>
          <Avatar
            src={user.avatar}
            sx={{
              height: 40,
              width: 40,
            }}>
            <UserCircleIcon fontSize="small" />
          </Avatar>
          <Box
            sx={{
              ml: 1,
            }}>
            <Typography variant="body1">{user.name}</Typography>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ my: 1 }}>
          {permissionService.check(['my-account.view'], permissions) &&
            <MenuItem onClick={handleMyAccount}>
              <ListItemIcon>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1">{t('My account')}</Typography>} />
            </MenuItem>}
          {permissionService.check(['dashboard.view'], permissions) &&
            <MenuItem onClick={handleDashboard}>
              <ListItemIcon>
                <SpaceDashboardIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1">{t('Dashboard')}</Typography>} />
            </MenuItem>}

          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={<Typography variant="body1">{t('Logout')}</Typography>} />
          </MenuItem>

        </Box>
      </Popover>
    );
  }
  return undefined;
};

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  returnUrl: PropTypes.string,
};

AccountPopover.defaultProps = {
  anchorEl: null,
  onClose: null,
  open: true,
  returnUrl: null
};
